// extracted by mini-css-extract-plugin
module.exports = {"lds-roller":"style_lds-roller__24q1V","div-after":"style_div-after__15bvr"};